import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder } from '@angular/forms';
import { FlashMessagesService } from 'angular2-flash-messages';

import * as _ from 'underscore';

// Service
import { CultureListService } from '../../service/culture-list/culture-list.service';

@Component({
	selector: 'app-culture-list',
	templateUrl: './culture-list.component.html',
	providers: [
		CultureListService,
		HttpModule
	]
})
export class CultureListComponent implements OnInit {

	private token;
	public cultures: any[] = [];
	public resultCount: number = 0;
	public orderby: string = "Descricao";
	public sort: string = "asc";
	public permissoes: any[] = [];
	currentPage: number = 0;
	culture: FormGroup;

	constructor(fb: FormBuilder, private cultureListService: CultureListService, private flashMessagesService: FlashMessagesService, private router: Router) {
		this.token = localStorage.getItem('yara.token');
		this.culture = fb.group({
			'Descricao': '',
			'UnidadeMedida':'',
			'Ativo': ''
		});
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
		this.searchCulture(this.culture.value, 0, false);
	}

	setOrder(orderby) {
		if (this.orderby != orderby) {
			this.sort = "asc";
		} else {
			this.sort = this.sort == "asc" ? "desc" : "asc";
		}
		this.orderby = this.orderby != orderby ? orderby : this.orderby;
		this.searchCulture(this.culture.value, this.currentPage, false);
	}

	searchCulture(value: any, page, isSearch) {
		if (isSearch) {
			this.orderby = "Descricao";
			this.sort = "asc";
			this.currentPage = 0;
		}
		this.cultureListService.searchCulture(this.token, value.Descricao,value.Ativo, this.orderby, this.sort, page).subscribe(result => {
			if (result.Success) {
				this.cultures = result.Result;
				this.resultCount = result.Count;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		})
	}

	paginar($event: any) {
		this.currentPage = $event;
		this.searchCulture(this.culture.value, $event, false);
	}
}



// WEBPACK FOOTER //
// ./src/app/culture/component/culture-list/culture-list.component.ts